// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dGNs03V","containerSm":"_9881ctgh","text":"_2YWgvvz7"};